import styled from 'styled-components';
export const DatepickerContentWrapper = styled.div `
  width: 323px;
  height: auto;
  background-color: #FFF;
  border: 1px solid #000;
  position: absolute;
  z-index: 11;
  top: 100%;
`;
export const DatepickerRangeSelector = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 5px 10px rgba(0,0,0,.08);
`;
export const DatepickerRangeButton = styled.div `
  position: relative;
  padding: 10px;
  cursor: pointer;
  &:hover { text-decoration: underline; }
  ${props => props.disabled ? 'pointer-events: none;opacity: .5;' : ''};
  ${props => props.selected ? `
    font-weight: 800;
    &:after {
      position: absolute;
      content: '';
      bottom: 0;
      left: 0;
      right: 0;
      height: 3px;
      background-color: ${props.theme.colors.secondary};
    }
  ` : ''}
`;
export const DatepickerMatrix = styled.div `
  
`;
export const DatepickerNavigator = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 15px 0px 15px;
`;
export const DatepickerCurrentDate = styled.div `
  font-weight: 800;
`;
export const NavigatorIconWrapper = styled.div `
  cursor: pointer;
  &:hover {
    svg {
      fill: ${props => props.theme.colors.primary};
    }
  }
`;
